import "./style.css";
import { initializeApp } from "firebase/app";
import {
  getFirestore, doc, setDoc, getDoc, getDocs, collection, deleteDoc
} from "firebase/firestore";
import {
  getAuth, onAuthStateChanged, GoogleAuthProvider,
  signInWithPopup, signOut, createUserWithEmailAndPassword, signInWithEmailAndPassword,
  sendEmailVerification 
} from "firebase/auth";
import {
  getStorage, ref, uploadBytes
} from "firebase/storage";
import { logEvent, getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyA5743453uGyIKCdpo5BAKs3vhmjmlDJSY",
  authDomain: "to-do-1d04e.firebaseapp.com",
  projectId: "to-do-1d04e",
  storageBucket: "to-do-1d04e.firebasestorage.app",
  messagingSenderId: "477690053260",
  appId: "1:477690053260:web:500da91195a9650e1a31a9",
  measurementId: "G-84Z03J4BT7"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app, "to-do-01");
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);
const analytics = getAnalytics(app);

document.addEventListener("DOMContentLoaded", () => {

  document.getElementById("emailSignUpBtn").addEventListener("click", () => {
  const email = document.getElementById("emailInput").value.trim();
  const password = document.getElementById("passwordInput").value.trim();
  if (!email || !password) {
    return alert("Please enter email and password.");
  }
  createUserWithEmailAndPassword(auth, email, password)
    .then(userCredential => {
      sendEmailVerification(userCredential.user)
      .then(() => {
        alert("Verification email sent. Please check your inbox.");
      })
      .catch((error) => {
        console.error("Error sending verification email:", error);
      });
    })
    .catch(error => {
      console.error("Registration error:", error);
      alert("Error registering user: " + error.message);
    });
});

document.getElementById("emailSignInBtn").addEventListener("click", () => {
  const email = document.getElementById("emailInput").value.trim();
  const password = document.getElementById("passwordInput").value.trim();
  if (!email || !password) {
    return alert("Please enter email and password.");
  }
  signInWithEmailAndPassword(auth, email, password)
    .then(userCredential => {
      if (!userCredential.user.emailVerified) {
        alert("Please verify your email before signing in.");
        return;
      }
      console.log("Signed in:", userCredential.user);
      alert("Sign-in successful!");
    })
    .catch(error => {
      console.error("Sign-in error:", error);
      alert("Error signing in: " + error.message);
    });
});

document.getElementById("googleSignInBtn").addEventListener("click", () => {
  signInWithPopup(auth, provider)
    .then(result => console.log("Signed in as: ", result.user.displayName))
    .catch(error => console.error("Sign-in error: ", error));
});


document.getElementById("signOutBtn").addEventListener("click", () => {
  signOut(auth).then(() => {
    console.log("Signed out");
  });
});


onAuthStateChanged(auth, async (user) => {
  const userInfo = document.getElementById("userInfo");
  const loggedInFields = document.querySelectorAll(".logged-in-only");
  const userImageDisplay = document.getElementById("userImageDisplay");
  if (user?.emailVerified) {
    console.log("User is signed in:", user);
    userInfo.textContent = `Signed in as: ${user.displayName || user.email}`;
    loggedInFields.forEach(el => el.style.display = "block");
    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);
    if (userSnap.exists() && userSnap.data().photoURL) {
      userImageDisplay.innerHTML = `<img src="${userSnap.data().photoURL}" alt="Profile Picture" style="max-width:150px; max-height:150px; border-radius: 50%;">`;
    } else {
      userImageDisplay.innerHTML = "";
    }
    readTasks();
  } else {
    userInfo.textContent = "Not signed in";
    loggedInFields.forEach(el => el.style.display = "none");
    userImageDisplay.innerHTML = "";
  }
});

document.getElementById("uploadUserImageBtn").addEventListener("click", async () => {
  const file = document.getElementById("userImageInput").files[0];
  if (!file) return alert("Please choose an image file");
  
  const user = auth.currentUser;
  if (!user) return alert("Please sign in first");

  try {
    const storageRef = ref(storage, `user_images/${user.uid}/${file.name}`);
    await uploadBytes(storageRef, file);
    const url = `https://firebasestorage.googleapis.com/v0/b/${firebaseConfig.storageBucket}/o/${encodeURIComponent(`user_images/${user.uid}/${file.name}`)}?alt=media`;

    const userRef = doc(db, "users", user.uid);
    await setDoc(userRef, { photoURL: url, name: user.displayName }, { merge: true });

    alert("Profile picture uploaded!");
    logEvent(analytics, 'file_uploaded', {
    fileName: file.name,
    fileSize: file.size
  });

    document.getElementById("userImageDisplay").innerHTML = `<img src="${url}" alt="Profile Picture" style="max-width:150px; max-height:150px; border-radius: 50%;">`;

  } catch (error) {
    console.error("Upload failed:", error);
    alert("Upload failed. See console for details.");
  }
});



document.getElementById("writeTaskBtn").addEventListener("click", async () => {

  const taskInput = document.getElementById("taskInput").value.trim();
  if (!taskInput) {
    return alert("Please enter a task");
  }

  try {
    const tasksSnapshot = await getDocs(collection(db, "tasks"));

    const newTaskId = `task${tasksSnapshot.size + 1}`;
    console.log("New task ID:", newTaskId);
    const taskRef = doc(db, "tasks", newTaskId);

    await setDoc(taskRef, {
      taskId: newTaskId,
      task: taskInput,
      done: false,
      user: auth.currentUser.displayName || auth.currentUser.email
    });
    logEvent(analytics, 'task_created', {
      taskId: newTaskId,
      task: taskInput,
      done: false,
      user: auth.currentUser.displayName || auth.currentUser.email
    });

    console.log("Task written:", newTaskId);
    readTask(newTaskId);
  } catch (error) {
    console.error("Error writing task:", error);
  }
});


async function readTask(taskId) {
  const taskRef = doc(db, "tasks", taskId);
  const taskSnap = await getDoc(taskRef);
  const output = document.getElementById("taskOutput");
  let doneStatus = "";
  if (taskSnap.exists()) {
    doneStatus = taskSnap.data().done ? "Done" : "Pending";
    output.innerHTML = `
      <div style="margin-bottom: 1rem;">
        <strong>${taskSnap.id}</strong>: ${taskSnap.data().task} |
        ${doneStatus} |
        ${taskSnap.data().user || "N/A"}
      </div>`;
  } else {
    output.innerHTML = "No task found.";
  }
}

document.getElementById("displayAllTasks").addEventListener("click", () => {
  readTasks();
  console.log("Displaying all tasks");
});

async function readTasks() {
  const querySnapshot = await getDocs(collection(db, "tasks"));
  const output = document.getElementById("tasksOutput");
  output.innerHTML = "<h3> All Tasks:</h3>";

  if (querySnapshot.empty) {
    output.innerHTML += "<p>No tasks found.</p>";
    return;
  }

  querySnapshot.forEach((doc) => {
    const taskData = doc.data();
    if(!taskData.user){
      return;
    }
    if(taskData.user && taskData.user !== auth.currentUser.displayName && taskData.user !== auth.currentUser.email) {
      return;
    }
    output.innerHTML += `
      <div style="margin-bottom: 1rem;">
        <strong>${doc.id}</strong>: ${taskData.task} | ${taskData.done ? "Done" : "Pending"} | ${taskData.user || "N/A"}
      </div>`;
  });
}

const fileInput = document.getElementById('userImageInput');
  const fileName = document.getElementById('userImageName');
  if (fileInput && fileName) {
    fileInput.addEventListener('change', function() {
      fileName.textContent = fileInput.files.length ? fileInput.files[0].name : '';
    });
  }

document.getElementById("deleteTaskBtn").addEventListener("click", async () => {
  const taskId = document.getElementById("taskIdInputDelete").value.trim();
  if (!taskId) return alert("Please enter a Task ID to delete.");

  try {
    await setDoc(doc(db, "tasks", taskId), {}, { merge: false });
    await deleteDoc(doc(db, "tasks", taskId));
    alert(`Task ${taskId} deleted!`);
  } catch (error) {
    console.error("Error deleting task:", error);
    alert("Error deleting task. See console for details.");
  }
});

document.getElementById("updateTaskBtn").addEventListener("click", async () => {
  const taskId = document.getElementById("taskIdInputUpdate").value.trim();
  const newTask = document.getElementById("taskUpdateInput").value.trim();
  if (!taskId || !newTask) return alert("Please enter both Task ID and new description.");

  try {
    const taskRef = doc(db, "tasks", taskId);
    await setDoc(taskRef, { task: newTask }, { merge: true });
    alert(`Task ${taskId} updated!`);
    readTasks();
  } catch (error) {
    console.error("Error updating task:", error);
    alert("Error updating task. See console for details.");
  }
});

});